module.exports = "/assets/data/8e270fc807b06f019468cdf52fb9ea11-KT17.data.json";